import { render, staticRenderFns } from "./RelatedMap.vue?vue&type=template&id=6d06b64c&scoped=true"
import script from "./RelatedMap.vue?vue&type=script&lang=js"
export * from "./RelatedMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d06b64c",
  null
  
)

export default component.exports